
import { defineComponent, onMounted } from "vue";
import animateCursor from "@/components/Shared/Cursor/animate";

export default defineComponent({
  name: "Cursor",

  setup() {
    onMounted(animateCursor);
  },
});
